import script from "./ImageCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageCard.vue?vue&type=script&setup=true&lang=js"

import "./ImageCard.vue?vue&type=style&index=0&id=bf0331a8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf0331a8"]])

export default __exports__